export default __webpack_public_path__ + "static/media/example.a830ac2f.mp3";